'use client';

import styled, { css } from 'styled-components';

import { device, hexToRGB } from '@/styles/helpers';

export const ScFooter = styled.div`
  position: relative;
  margin-top: auto;

  & > div {
    margin-top: 48px;
  }
`;

export const ScFooterItem = styled.div`
  padding: 18px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  &:first-child {
    border-top: 1px solid ${({ theme }) => hexToRGB(theme.whiteColor, 0.2)};
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => hexToRGB(theme.whiteColor, 0.2)};
  }

  &:last-child {
    flex-direction: column;
  }

  @media (${device.mobile}) {
    flex-direction: column;
    padding: 15px 0;
  }
`;

export const ScLicense = styled.div`
  flex-shrink: 0;
`;

export const ScFooterCopyright = styled.div`
  font-size: 12px;
  line-height: 20px;
  color: ${({ theme }) => theme.blackLightColor};
  text-align: center;
  padding: 50px 0 9px;
  white-space: break-spaces;

  p {
    margin-top: 16px;
    &:last-of-type {
      margin-top: 0;
    }
    &:nth-last-of-type(1),
    &:nth-last-of-type(2) {
      color: ${({ theme }) => theme.redColor};
    }
  }

  a {
    color: ${({ theme }) => theme.secondaryColor};
    text-decoration: underline;
    cursor: pointer;
    font-weight: bold;
    transition: 0.3s;

    &:hover {
      color: ${({ theme }) => theme.secondaryColorHover} !important;
    }
  }

  @media (${device.mobile}) {
    font-size: 10px;
    text-align: center;

    padding: 48px 0 24px;
  }
`;

export const ScAppLinks = styled.div`
  display: flex;
  align-self: center;
  flex-wrap: nowrap;
  gap: 16px;
  margin: 0 0 0 65px;

  img {
    height: 40px;
    width: 135px;
  }

  @media (${device.mobile}) {
    margin: 32px auto 0;
    gap: 10px;
  }

  a {
    display: block;
    transition:
      transform 0.2s ease-in-out,
      filter 0.2s ease-in-out;
    img {
      max-width: 100%;
    }

    @media (hover: hover) {
      &:hover {
        transform: scale(1.1);
        filter: contrast(1.5);
      }
    }
  }
`;

export const ScFooterItemLeft = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-top: 30px;

  @media (${device.mobile}) {
    position: relative;
  }

  @media (${device.mobile}) {
    justify-content: center;

    flex-direction: column;
  }

  & > button,
  & > a {
    z-index: 1;

    &:not(:last-child) {
      margin-right: 16px;
    }
  }

  & > .icon_wrapper {
    display: flex;

    @media (${device.mobileS}) {
      flex-direction: column;
      align-items: center;
      gap: 32px;
    }

    @media (${device.mobileXS}) {
      width: 100%;
    }
  }
`;

export const ScFooterItemRight = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;

  align-items: center;
  width: 100%;
  @media (${device.mobile}) {
    justify-content: center;
  }
`;

export const ScFooterImagesGroup = styled.div<{
  isAwardImages?: boolean;
}>`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 100%;

  @media (${device.mobile}) {
    justify-content: center;
    &:has(> img) {
      gap: 12px 18px;

      ${({ isAwardImages }) =>
        isAwardImages &&
        css`
          & > img {
            width: calc(50% - 9px);
          }
        `}
    }
  }

  a {
    display: flex;

    transition: transform 0.2s ease-in-out;

    @media (hover: hover) {
      &:hover {
        transform: scale(1.1);
      }
    }
  }

  & img {
    object-fit: contain;
    max-width: 100%;
    max-height: 60px;
  }
`;

export const ScMenuBottom = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  padding: 32px 0 27px;
  width: 100%;
  margin: -8px;
  text-align: center;

  @media (${device.mobile}) {
    flex-direction: column;
  }
  & > li {
    padding: 8px;
    @media (${device.mobile}) {
      padding: 16px 8px;
    }
    & > button {
      background: none;
      cursor: pointer;
      border: none;
      outline: none;
    }

    &.active > a,
    &.active > button {
      @media (${device.tablet}) {
        color: ${({ theme }) => theme.mainColor};
      }
    }

    & > a,
    button {
      display: inline-block;
      color: ${({ theme }) => theme.whiteColor};
      text-decoration: none;
      text-transform: uppercase;
      font-weight: 700;
      font-size: 16px;
      line-height: 19px;
      position: relative;
      transition: 0.2s;
      &:hover {
        color: ${({ theme }) => theme.mainColor};
        @media (${device.mobile}) {
          color: ${({ theme }) => theme.whiteColor};
        }
      }
      &.active {
        @media (${device.tablet}) {
          color: ${({ theme }) => theme.mainColor};
        }
      }
    }
  }
`;

export const ScFooterSocialLinks = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  padding-left: 13px;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.whiteColor};
  white-space: nowrap;

  a {
    transition: transform 0.2s ease-in-out;

    svg {
      display: block;
    }

    @media (hover: hover) {
      &:hover {
        transform: scale(1.1);
      }
    }
  }
`;
